import { Box, Tooltip, Typography } from "src/components/MuiGenerals";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { GetListRes } from "../types/GetListRes";
import { TableColumnKey } from "../types/Table";

const useTotalBalanceCell = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const renderTotalBalanceCell = (params: Params<GetListRes>) => {
    const totalAmount = params?.row?.[TableColumnKey.TotalBalance];
    const thresholdTotalAmount = params?.row?.thresholdTotalAmount;
    const currency = params?.row?.rawData.asset_name;

    if (params?.row?.isAmountLargerThanThreshold) {
      return (
        <Tooltip
          title={`${t("total_balance_tooltip", {
            amount: thresholdTotalAmount,
            currency: currency,
          })}`}>
          <Box display={"flex"} alignItems={"center"} gap={"0.5rem"}>
            <Typography color={"red"} children={`${totalAmount}`} />
          </Box>
        </Tooltip>
      );
    }

    return (
      <Tooltip title={totalAmount}>
        <Typography children={totalAmount} />
      </Tooltip>
    );
  };

  return { renderTotalBalanceCell };
};
export default useTotalBalanceCell;
